var map = {
	"./ContainerMountPaths.vue": 47495,
	"./Mount.vue": 8943,
	"./awsElasticBlockStore.vue": 85946,
	"./azureDisk.vue": 13126,
	"./azureFile.vue": 3144,
	"./emptyDir.vue": 7492,
	"./gcePersistentDisk.vue": 62842,
	"./hostPath.vue": 7146,
	"./index.vue": 64461,
	"./nfs.vue": 81119,
	"./secret.vue": 48974,
	"./vsphereVolume.vue": 66542,
	"edit/workload/storage/ContainerMountPaths.vue": 47495,
	"edit/workload/storage/Mount.vue": 8943,
	"edit/workload/storage/awsElasticBlockStore.vue": 85946,
	"edit/workload/storage/azureDisk.vue": 13126,
	"edit/workload/storage/azureFile.vue": 3144,
	"edit/workload/storage/emptyDir.vue": 7492,
	"edit/workload/storage/gcePersistentDisk.vue": 62842,
	"edit/workload/storage/hostPath.vue": 7146,
	"edit/workload/storage/index.vue": 64461,
	"edit/workload/storage/nfs.vue": 81119,
	"edit/workload/storage/secret.vue": 48974,
	"edit/workload/storage/vsphereVolume.vue": 66542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68219;